import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Table,
  // TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
} from "@mui/material";
import { useHistoryContext } from "../context/HistoryContext";

const HistoryPage = () => {
  const { history } = useHistoryContext();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedHistory = history.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Histórico de Análises
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Data</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Detalhes</TableCell>
              </TableRow>
            </TableHead>
            {paginatedHistory
              .filter(
                (entry) => entry && entry.date && entry.type && entry.details
              ) // Filtra entradas inválidas
              .map((entry, index) => (
                <TableRow key={index}>
                  <TableCell>{new Date(entry.date).toLocaleString()}</TableCell>{" "}
                  {/* Formata a data */}
                  <TableCell>{entry.type}</TableCell>
                  <TableCell>{entry.details}</TableCell>
                </TableRow>
              ))}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 30]}
          component="div"
          count={history.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Container>
  );
};

export default HistoryPage;
